<template>
  <md-app md-waterfall md-mode="fixed" class="fullheight">
    <md-app-toolbar class="md-primary">
      <span class="md-title" style="flex: 1">Team Texting </span><span class="md-title" style="flex: 1">{{ teamname }}</span>
      <span v-if="userfirstname">{{ userfirstname + ' ' + userlastname }} &lt;</span>{{ useremail }}<span v-if="userfirstname">&gt;</span>
      <!-- <md-button class="md-icon-button" v-on:click="reloadPage()">
        <md-icon>refresh</md-icon>
        <md-tooltip md-direction="bottom">Reload the whole page</md-tooltip>
      </md-button> -->
      <!-- <md-button class="md-icon-button" v-on:click="updateScroll()">
        <md-icon>
          arrow_downward
          <md-tooltip md-direction="bottom">Scroll to newest message</md-tooltip>
        </md-icon>
      </md-button> -->
      <md-menu md-size="medium" md-align-trigger>
        <md-button md-menu-trigger class="md-icon-button">
          <md-icon>
            more_vert
            <md-tooltip md-direction="bottom">Menu</md-tooltip>
          </md-icon>
        </md-button>
        <md-menu-content>
          <md-menu-item>
            <md-icon>
              account_circle
            </md-icon>
            <span class="md-list-item-text" v-if="userfirstname">{{ userfirstname + ' ' + userlastname }}</span><span v-else class="md-list-item-text">&lt;{{ useremail }}&gt;</span>
          </md-menu-item>
          <Setup/>
          <md-menu-item @click='logout'>
            <md-icon>
              cancel
              <md-tooltip md-direction="left">
                <span>Log out</span>
              </md-tooltip>
            </md-icon>
            <span class="md-list-item-text">Log Out</span>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </md-app-toolbar>
    <md-app-drawer md-permanent="clipped" class="md-elevation-4">
      <ActiveConversations v-bind:lastupdate="this.teamlastupdate">
      </ActiveConversations>
    </md-app-drawer>
    <md-app-content class="content md-scrollbar">
      <Conversation v-bind:contactSMS="this.selectedcontactSMS">
      </Conversation>
    </md-app-content>
  </md-app>
</template>

<script>
import firebase from 'firebase'
import { mapState } from 'vuex'
import Setup from '@/components/Setup'
import ActiveConversations from '@/components/ActiveConversations'
import Conversation from '@/components/Conversation'

export default {
  components: {
    Setup,
    ActiveConversations,
    Conversation
  },
  name: 'dashboard',
  computed: {
    ...mapState([
      'userfirstname',
      'userlastname',
      'useremail',
      'usercolor',
      'userlevel',
      'userTwilioAccountSID',
      'teamTwilioAccountSID',
      'teamTwilioAuthToken',
      'teamTwilioSMSNumber',
      'teamname',
      'teamlastupdate',
      'teamlastcommfrom',
      'selectedcontactSMS',
      'forceConversationUpdate',
      'globalcontacthistory'
    ])
  },
  data () {
    return {
      loading: true,
      sending: false
    }
  },
  methods: {
    logout: function () {
      console.log('Logging out!')
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    },
    updateScroll () {
      if (!this.scrolled) {
        var element = document.getElementById('messageswindow')
        element.scrollTop = element.scrollHeight
      }
    },
    reloadPage () {
      console.log('reload clicked.')
      location.reload()
    }
  }
}
</script>

<style scoped>
.content {
  height: calc( 100vh - 70px );
}
.md-app-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}
.left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue